import { useMutation } from "@tanstack/react-query"

import {
  createScheduledMessage,
  deleteScheduledMessage,
  updateScheduledMessage,
} from "./api"
import { queryClient } from "../../queryClient"
import { QueryKey } from "../../types/queries"

export const useCreateScheduledMessageMutation = () =>
  useMutation({
    mutationFn: createScheduledMessage,
    onSuccess: async () => {
      await queryClient.invalidateQueries([QueryKey.SCHEDULED_MESSAGES])
    },
  })

export const useUpdateScheduledMessageMutation = () =>
  useMutation({
    mutationFn: updateScheduledMessage,
    onSuccess: async () => {
      await queryClient.invalidateQueries([QueryKey.SCHEDULED_MESSAGES])
    },
  })

export const useDeleteScheduledMessageMutation = () =>
  useMutation({
    mutationFn: deleteScheduledMessage,
    onSuccess: async () => {
      await queryClient.invalidateQueries([QueryKey.SCHEDULED_MESSAGES])
    },
  })
